import React from 'react';

import autoBind from 'react-autobind';

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"
import LocaleOverviewStageElement from "composer/views/locale/LocaleOverviewStageElement.jsx"

import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Icon,
  Divider,
} from '@material-ui/core';
import Helper from "composer/Helper.jsx";

class LocaleOverviewStage extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();

    // state variables here
    this.state = {
      // aNumber : 1,
      // aString: "abc",
      // anArray: [],
      // anObject: {},
    };
    autoBind(this);
  }

  stagePreview() {
    if (this.props.stageData.movie_list != null && this.props.stageData.movie_list.length > 0) {
      return (
        <img
          style={{maxHeight:"100%", maxWidth:"100%", display:"block", margin:"auto", borderRadius:4}}
          src={Config.BASE_PATH() + this.props.stageData.movie_list[0].tn_path}
        />
      )
    }
  }

  playbackItem(playbackData) {
    return (
      <ListItem key={playbackData.id} alignItems="flex-start">
        <ListItemAvatar>
          <Icon>{Config.GET_PLAYBACK_CONFIG(parseInt(playbackData.kind))['icon']}</Icon>
        </ListItemAvatar>
        <ListItemText>
          <LocaleOverviewStageElement root={this.props.root} parent={this} playbackData={playbackData}/>
        </ListItemText>
      </ListItem>
    )
  }

  render() {
    return (
      <div>
        <Divider variant="middle"/>
        <Card style={{margin:"0 0 16px 0"}} elevation={0}>
          <CardHeader
            title={this.props.stageData.stage_name + " - " + Helper.fToHHMMSS(this.props.stageData.duration)}
          />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                {this.stagePreview()}
              </Grid>
              <Grid item xs={12} sm={6}>
                <List>
                  {this.props.stageData.playback_list.map( (row, i) => {
                    return (
                      this.playbackItem(row)
                    );
                  })}
                </List>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
    )
  }
}

export default LocaleOverviewStage;
